// src/components/UtcTime.tsx
import React, { useEffect, useState } from 'react';

const formatUtcDate = (date: Date): string => {
  const pad = (n: number) => (n < 10 ? '0' : '') + n;
  let hours = date.getUTCHours();
  const minutes = pad(date.getUTCMinutes());
  const seconds = pad(date.getUTCSeconds());
  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12;
  hours = hours ? hours : 12;

  const day = pad(date.getUTCDate());
  const month = pad(date.getUTCMonth() + 1);
  const year = date.getUTCFullYear();

  return `UTC Time: ${day}/${month}/${year} ${hours}:${minutes}:${seconds} ${ampm}`;
};

const UtcTime: React.FC = () => {
  const [utcTime, setUtcTime] = useState<string>(formatUtcDate(new Date()));

  useEffect(() => {
    const timer = setInterval(() => {
      setUtcTime(formatUtcDate(new Date()));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return <div>{utcTime}</div>;
};

export default UtcTime;
